'use client';

import { Box, Container, Typography } from '@mui/material';
import JobPostingForm from 'components/jobs/JobPostingForm';

export const dynamic = 'force-dynamic';

export default function CreateJobPage() {
  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 4 }}>
        <Typography variant="h4" gutterBottom>
          Create a New Job
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Post your design or manufacturing job to find the perfect maker for your project.
        </Typography>
        <JobPostingForm />
      </Box>
    </Container>
  );
}
